module.exports = __webpack_public_path__ + "img/phone-call.b97efbd0.svg";